import { createClient } from "@supabase/supabase-js";
export const supabase = createClient(
  "https://syfmbqampybmzgiofvzp.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN5Zm1icWFtcHlibXpnaW9mdnpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODcxMzM5MDMsImV4cCI6MjEwMjcwOTkwM30.Wn3xKIUpXB8iuV3QHnFuFqAqburBdZf6kucB_FV99zk"
);
